<template>

	<div class="page page-1 guide-1">
		<van-nav-bar title="个人中心" fixed placeholder />

		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">


			<div class="s1">
				<div class="b1">
					<div><a href="javascript:void(0)" class="p1">未使用个人号开群数：<span class="c1">{{unused}}</span></a></div>
					<div><a href="javascript:void(0)" class="btn-buy" @click="goBuy">立即购买</a></div>
				</div>
			</div>

			<div class="s2" v-show="show_qrcode==0" v-if="wechat_info_show==0 && is_loadok">
				<div class="b1 flex h-between">
					<div><b>登录个人号</b></div>
				</div>
				<div class="pb-3">
					<div class="b3">
						<div class="icon" @click="addAccount"><img src="../../assets/icon-2.png"></div>
						<div class="p1">添加个人号</div>
					</div>
				</div>
			</div>
			<div class="s2" v-if="wechat_info_show">
				<div class="b1 flex h-between">
					<div><b>我的个人号</b></div>
					<div><a href="javascript:void(0)" class="fs-12 color-primary" @click="addAccount">更换个人号 &gt;</a></div>
				</div>
				<div class="pb-3">
					<div class="b2 flex">
						<div>
							<div class="avatar"><img :src="wechat_info.headimgurl"></div>
						</div>
						<div>
							<div class="p1">{{wechat_info.nickname}}</div>
							<div class="p2" v-if="!wechat_info.status">状态：<span style="color: red;">离线</span><a @click="twiceLogin" href="javascript:void(0)"
								 class="color-primary ml-2">重新上线</a></div>
							<div class="p2" v-else>状态：<span>在线</span><a @click="offLogin" href="javascript:void(0)"
								 class="color-primary ml-2">点我下线</a></div>

							<div style="display: inline-block;margin-top: 0.05rem;width: 1rem;" @click="showQuestionMsg">
								<van-icon name="question-o" color="#1989fa" />
							</div>

						</div>
					</div>
				</div>
			</div>

			<!-- <div class="s3" v-if="wechat_info_show">
				<div class="b1 flex h-between">
					<div><b>个性化</b></div>
				</div>
				<van-grid :column-num="5" square :border="false" clickable>
					<van-grid-item :icon="require('../../assets/icon-lixian.png')" text="掉线提醒" @click="diaoxiantixing" />
				<van-grid-item :icon="require('../../assets/icon-room.png')" text="换群" @click="huanqun" />
				<van-grid-item :icon="require('../../assets/icon-jiaohuan.png')" text="群克隆" @click="qunkelong" />
					<van-grid-item :icon="require('../../assets/icon-jiaohuan.png')" text="成为代理" @click="daili" badge="热" />
				</van-grid>
			</div> -->

			<div class="s3" v-if="wechat_info_show && wechat_group.length <= 0">
				<div class="b1 flex h-between">
					<div><b>群列表</b></div>
				</div>
				<div class="b2">
					<div class="b2-1">
						<div class="p1">您已登录为个人号，如何让个人号激活群功能？</div>
						<div class="p2"><img src="../../assets/icon-4.png"></div>
						<div class="p3">
							<div class="wrap">点击<span class="color-primary">【添加新群】</span>，将您需要开通小助手的群添加到这里即可。</div>
						</div>
						<div class="p4"><a href="javascript:void(0)" class="btn-add" @click="gotoGroup">添加新群</a></div>
					</div>
				</div>
			</div>
			<div class="s3" v-else-if="wechat_group.length > 0">
				<div class="b1 flex h-between">
					<div><b>群列表</b></div>
					<div><a href="javascript:void(0)" class="btn-add" @click="gotoGroup">添加新群</a></div>
				</div>
				<van-list>
					<van-cell v-for="item in wechat_group" :key="item.id" clickable size="large" :title="item.nickname" :icon="item.headimgurl"
					 @click="showMenu(item.id)">
						<template #label>
							<div style="font-size: 12px;">
								<span>到期时间 {{item.expires_date}}</span>
								<div style="display: inline-block;margin-left: 10px;color: red;" v-if="item.is_end">[已到期]</div>
							</div>
						</template>
					</van-cell>
				</van-list>
				<van-action-sheet v-model="show" :actions="actions" @select="onSelect" cancel-text="取消" close-on-click-action
				 description="请选择一个操作" duration="0.2" />
			</div>


			<div class="guide-1-box" v-if="show_descript && !wechat_info_show">
				<div class="wrap" style="margin-top: 2.8rem;">
					<div class="p1"><img src="../../assets/icon-3.png"></div>
					<div class="p3">
						<div class="p3-1">点击<span class="color-primary">【添加个人号】</span>，将您的个人号扫码登录到平台；
						</div>
						<div class="p4"><a href="javascript:void(0)" class="btn-cus" @click="closeDescript">知道了</a></div>
					</div>
				</div>
			</div>





			<div class="p-popup popup1" v-if="show_qrcode">
				<div class="mask"></div>
				<div class="main">
					<div class="p-popup-title">扫码方法，请往下看↓<a v-if="qrcode_url" href="javascript:void(0)" @click="closeQrcode" class="p-popup-close"></a></div>
					<div class="p-popup-body">
						<div class="b1">
							<p class="mb-1">1.请准备两台设备（或让身边好友帮忙），用一台设备打开登录链接进入扫码界面，再用另一台设备中的微信的【扫一扫】功能对二维码进行扫码授权。（注：扫码登录的个人号为助手号）。</p>
						</div>
						<div class="divider my-2"></div>
						<div class="b2">
							<div class="qrcode" v-show="show_qrcode">
								<!-- <img :src="qrcode_base64_data">
							<div class="loading" v-show="qrcode_base64_data==''">{{qrcode_loading_text}}</div> -->
								<img :src="qrcode_url">
								<div class="loading" v-show="qrcode_url==''">{{qrcode_loading_text}}</div>
								<!---->
							</div>
							<div class="p1">（不支持微信内截图/长按识别扫码）</div>

							<a href="javascript:void(0)" class="btn-cus" v-show="qrcode_url" @click="getLoginQrcode">刷新二维码</a>

							<div class="divider my-2"></div>
							<div class="b1">
								<p><b>温馨提示</b></p>
								<p class="mb-1">1.二维码有效期为5分钟，若扫描后提示失效，请点击【刷新二维码】</p>
								<p>2.若无法完成扫码，请联系客服</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="text-align: center;margin: 20px 0 1rem 0;color: #007AFF;font-size: 14px;">
				<a @click="goFeedbook">投诉</a>
			</div>
			<div style="height: 50px;"></div>
			<van-popup v-model="show_group_tip">
				<div style="text-align: center;width: 2.5rem;"><img style="width: 2.3rem;border-radius: 10px;" src="../../assets/group_tip.gif" /></div>

				<div style="width: 100%;text-align: center;">
					<button @click="gotoGroup" style="border: 1px solid white;font-size: 0.16rem;border-radius: 6em;background: none;width: 82%;height: 0.35rem;line-height: 0.35rem;margin-top: 10px;">我知道了</button>
				</div>

			</van-popup>
		</van-pull-refresh>
	</div>

</template>

<script>
	import Vue from 'vue';
	import {
		List,
		Cell,
		ActionSheet,
		Popup,
		Grid,
		GridItem,
		PullRefresh,
		Notify
	} from 'vant';
	Vue.use(Grid);
	Vue.use(GridItem);
	Vue.use(List);
	Vue.use(Cell);
	Vue.use(ActionSheet);
	Vue.use(Popup);
	Vue.use(Notify);
	Vue.use(PullRefresh);
	export default {
		data() {
			return {
				isLoading: false,
				show_group_tip: false,

				select_id: 0,
				show: false,
				actions: [{
					id: 1,
					name: '群中心',
					color: '#288CFA'
				}, {
					id: 2,
					name: '续费',
					color: '#07c160'
				}],

				show_qrcode: false,
				qrcode_loading_text: '加载中...',
				qrcode_base64_data: '',
				qrcode_url: '',

				check_login_time_out: null,

				show_descript: 0,

				wechat_info: {},
				wechat_info_show: 0,

				wechat_group: [],

				unused: 0, //未使用群数,

				is_loadok: false
			}
		},

		mounted() {
			this.getInfo()
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					this.getInfo()
				}, 1000);
			},
			
			getInfo(){
				if(this.check_login_time_out != null) {
					clearInterval(this.check_login_time_out)
				}
				
				this.$ApiUtil.Member.getInfo().then(res => {
					this.wechat_info = res.account
					this.wechat_info_show = res.wechat_info_show
				
					this.wechat_group = res.groups
				
					this.unused = res.unused
				
					this.is_loadok = true
				
					this.show_descript = !res.wechat_info_show
				
					localStorage.setItem('unused', res.unused)
					
					this.isLoading = false
					this.show_qrcode = false
				})
			},
			showQuestionMsg() {
				Notify({
					type: 'primary',
					message: '状态需要保持在线，功能才能正常使用'
				});
			},
			goBuy() {
				this.$router.push('/')
			},
			daili() {
				this.$dialog.confirm({
					title: '成为代理',
					message: '您已有资格成为代理,是否现在申请?'
				}).then(() => {
					this.$router.push('/agent-confirm')
				})
			},
			diaoxiantixing() {

			},
			qunkelong() {

				this.$toast('敬请期待')
			},
			huanqun() {
				this.$toast('敬请期待')
			},
			goFeedbook() {
				this.$router.push('/feedbook-center')
			},
			onSelect(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show = false
				switch (item.id) {
					case 1:
						this.$router.push(`/group-display-${this.select_id}`)
						break;
					case 2:
						this.$router.push(`/group-resur-${this.select_id}`)
						break;
				}


			},
			showMenu(select_id) {
				this.select_id = select_id
				this.show = true
			},

			closeDescript() {
				this.show_descript = 0
			},
			closeQrcode() {
				this.show_qrcode = 0
				clearInterval(this.check_login_time_out)
			},
			openQrcode() {
				this.show_qrcode = 1
			},
			addAccount() {
				this.openQrcode()
				this.getLoginQrcode()
			},
			showGroupTip() {
				this.show_group_tip = !this.show_group_tip
			},
			gotoGroup() {
				if (this.show_group_tip) {
					this.$router.push('/member-addGroup')
				}

				this.showGroupTip()
			},
			getLoginQrcode() {
				clearInterval(this.check_login_time_out)
				// this.qrcode_base64_data = ''
				this.qrcode_url = ''
				this.$ApiUtil.Account.getQrCode().then(res => {
					if (res.status) {
						this.qrcode_url = res.qrcode
						//var uuid = res.uuid

						this.check_login_time_out = setInterval(() => {
							this.$ApiUtil.Account.loginStatus().then(res => {
								if (res.headimgurl) {
									this.qrcode_url = res.headimgurl
								}
								if (res.status) {
									this.$toast("登录成功")
									this.closeQrcode()
									// this.wechat_info.nickname = res.nickname
									// this.wechat_info.headimgurl = res.headimgurl
									// this.wechat_info.status = 1

									// this.wechat_info_show = 1
									this.$router.go(0)
								}
							})
						}, 1500)
					} else {
						this.closeQrcode(),
							this.$dialog.alert({
								message: res.message
							})
					}

				})
			},
			twiceLogin() {
				this.$ApiUtil.Account.twiceLogin().then(res => {
					if (!res.status) {
						this.$toast.fail('需要重新扫描二维码')
						this.addAccount()
						return;
					}
					this.$dialog.alert({
						message: '重新上线成功'
					}).then(() => {
						this.$router.go(0)
					})

				})
			},
            offLogin(){
                this.$dialog.confirm({
                	message: '真的要这样做吗?'
                }).then(() => {
                	this.$ApiUtil.Account.offLogin().then( res => {
                	    if (res.status) {
                	    	this.$dialog.alert({
                	    		message: '下线成功'
                	    	}).then(() => {
                	    		this.$router.go(0)
                	    	})
                	    }
                	} )
                }).catch(() => {})
            }
		}
	}
</script>

<style scoped>
	.van-icon__image {
		width: 3em;
		height: 3em;
		margin-right: 5px;
	}

	.van-popup--center {
		color: white;
		background: none;

		line-height: 1.8em;
		font-size: 12px;
		height: 6rem;

	}
</style>
